import { FunctionComponent } from 'react';
import styles from './Commissions.module.scss';
import CommissionsDetail from 'components/Payments/CommissionDetail/CommissionDetail';

interface CommissionsProps {
    description?: string;
}

export const Commissions: FunctionComponent<CommissionsProps> = props => {
    return (
        <div>
            <div className={styles.description}>{props.description}</div>
            <CommissionsDetail showTitle={false} />
        </div>
    );
};

export default Commissions;
